import { render, staticRenderFns } from "./index_resilience_kecermatan.vue?vue&type=template&id=a60cd250&scoped=true&"
import script from "./index_resilience_kecermatan.vue?vue&type=script&lang=js&"
export * from "./index_resilience_kecermatan.vue?vue&type=script&lang=js&"
import style0 from "./index_resilience_kecermatan.vue?vue&type=style&index=0&id=a60cd250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60cd250",
  null
  
)

export default component.exports